/* global __doPostBack*/

import { btnLoader } from '../common/Utils';
import { UltimateForms } from '../common/Ultimateform';
import KeyCodes from '../common/KeyCodes';
import GDPR from '../plugins/gdpr_birthdate_validation';
import { ValidateOptin, ValidateConsent, HandleGDPRValidationError, ValidateRelatedField, ScrollToFirstErrorOccur } from '../common/molecule/optin-channels';
import { IsAllOptinValid } from '../common/molecule/agree-to-all-optin';

require('jquery-validation');
require('core-js/es/promise');

const _ = {};
_.template = require('lodash/template');

class PasswordValidation {

  IsValid(password) {
    const regPassword = /([a-z].*[0-9]|[0-9].*[a-z])/i;
    const minimumLength = 8;

    return regPassword.test(password) && password.length >= minimumLength;
  }
}

class FormValid {
  // class constructor
  constructor(target) {
    this.$tar = $(`.${target}`);
    this.tarClass = target;

    // list of available param
    this.param = {
      btnSubmitClass: null,
      inputStyleClass: null,
      errorTemplate: null,
      closeErrorTemplateBtnClass: null,
      updateHeight: false,
      countries: [
        'australia',
        'belgium',
        'brazil',
        'canada',
        'czech-republic',
        'france',
        'germany',
        'hong-kong',
        'india',
        'indonesia',
        'italy',
        'japan',
        'korea',
        'malaysia',
        'melvita-eu',
        'netherlands',
        'norway',
        'portugal',
        'russia',
        'slovakia',
        'spain',
        'taiwan',
        'sweden',
        'switzerland',
        'united-kingdom',
        'united-states',
      ],
    };
  }

  /**
   * global init FormValid Class
   * @method init
   * @param  {object} param list of available param displayed bellow
   */
  init(param) {
    Object.assign(this.param, param);
    this.initFormEvent();
    $(document).on('initVerifForm', () => {
      this.initFormEvent();
    });
  }

  /**
   * Special case event setup
   * @method specialCaseHandler
   */
  specialCaseHandler() {
    const $newUser = $('.m-signin--newuser');

    if ($newUser.length) {
      // Keyboard event new-user special case
      $newUser.on('keydown', (event) => {
        if (event.keyCode === KeyCodes.enter) {
          event.preventDefault();
          event.stopImmediatePropagation();
          $newUser.find('[type=submit]').trigger('click');
        }
      });
    }
  }

  /**
   * event function to init form verification plugin / support multiple form in webform \o/
   * @method initFormEvent
   */
  initFormEvent() {
    this.$tar = $(`.${this.tarClass}`);

    /* Special case todo */
    this.specialCaseHandler();

    if (!this.$tar.length) {
      return;
    }

    this.loadQASValidationScript();

    this.loadCountriesScript();

    this.$formTar = this.$tar.closest('form');
    this.inWait = false;
    this.isAjaxForm = this.$tar.data('ajaxform');
    const self = this;
    this.$formTar.validate({
      errorPlacement: () => false,
      highlight: element => self.highlightCallback(element),
      unhighlight: element => self.unhighlightCallback(element),
      ignore: ':not(:input[required])',
    });
    this.passwordCheck();
    const btnLoad = btnLoader($(`.${this.param.btnSubmitClass}`));

    // find the submit button in each form and add click trigger to launche verification
    $(`.${this.param.btnSubmitClass}`).on('click', (event) => {
      event.preventDefault();
      btnLoad.wait();
      if (this.inWait) {
        return false;
      }
      this.inWait = true;
      const $btn = $(event.currentTarget);

      const $validationGroup = $(event.target).closest('.validationGroup');
      const $wrapper = $validationGroup.length ? $validationGroup : $btn.closest(`.${this.tarClass}`);

      const thisObj = {
        currentForm: $wrapper,
      };
      thisObj.$allElement = thisObj.currentForm.find(':input').not('.disabled, [disabled]');
      this.recalculHeight(thisObj.currentForm, 'noH');
      this.validAllInput(thisObj.currentForm, undefined, true)
      .then((result) => {
        if (result && this.isAjaxForm) {
          $(document).trigger('formSubmitted', {
            isValid: result,
            form: UltimateForms().get(OCMS.currentForm.FormId),
            formId: OCMS.currentForm.FormId || null,
            callback: () => {
              __doPostBack(OCMS.currentForm.submit.UniqueID, '');
            }
          });
        } else if (result === true) {
          const $postback = $btn.attr('href');
          /* eslint-disable */
          if (typeof $postback !== 'undefined' && $postback.indexOf('javascript:__doPostBack') > -1) {
            eval($postback);
        }
          /* eslint-enable */
        }
        this.inWait = false;
        btnLoad.resume();
      });
      this.recalculHeight(thisObj.currentForm, 'calcH');
      this.resetForm(thisObj);
      return !this.isAjaxForm;
    });

    // handle zip code for country SWEDEN
    this.isZipFieldSpecificSweden();
  }

  isZipFieldSpecificSweden() {
    if (OCMS.GlobalVars.C === 25
      && OCMS.GlobalVars.Brand === 'occ'
      && $('[data-id="myaccount"]').length) {
      const $zipCodeAccount = $('[data-id="myaccount"]').find('[data-id="zip"]');

      $zipCodeAccount.on('keypress', (e) => {
        const charCode = (e.which) ? e.which : e.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          this.highlightCallback($zipCodeAccount);
          return false;
        }
        this.unhighlightCallback($zipCodeAccount);
        return true;
      });
    }
  }

  GDPRBirthdateIsMinor(formWrapper) {
    if (formWrapper.length === 0) {
      return false;
    }
    const $parentSelect = formWrapper.find('.m-private-input--birthday');
    // const $requiredBd = $parentSelect.find('select[required]');
    if ($parentSelect === undefined || $parentSelect.length === 0) {
      return false;
    }
    const $listBdSelect = $parentSelect.find('select');
    const isBirthDayRequired = this.isValidBirthDayRequired();
    return GDPR.GDPRBirthdateValidation($parentSelect,
      $listBdSelect[0][$listBdSelect[0].selectedIndex].value,
      $listBdSelect[1][$listBdSelect[1].selectedIndex].value,
      $listBdSelect[2][$listBdSelect[2].selectedIndex].value, isBirthDayRequired);
  }

  isValidBirthDayRequired() {
    if ((!$('#field_DateOfBirth_Day').hasClass('required')) ||
        (!$('#field_DateOfBirth_Month').hasClass('required')) ||
        (!$('#field_DateOfBirth_Year').hasClass('required'))
      ) {
      return false;
    }
    return true;
  }

  /**
   * check all input in selected wrapper for validation
   * @method validAllInput
   * @param  {css class selector} formWrapper   wrapper target
   * @param  {Boolean}     [ignoreHidden=false] ignore hidden input
   * @param  {Boolean}     [promise=false]      enable promise callback
   * @return {Boolean}                          return if form was submited
   */
  validAllInput(formWrapper, ignoreHidden = false, promise = false) {
    let formSubmit = true;

    const isUltimateForm = OCMS.currentForm != null;
    if (isUltimateForm) {
      ValidateRelatedField();
      ScrollToFirstErrorOccur();
      const isOptinConsentValid = ValidateConsent();
      const isOptinSelectionValid = ValidateOptin();
      const hasAgreedToAll = IsAllOptinValid();

      HandleGDPRValidationError(isOptinConsentValid, isOptinSelectionValid, hasAgreedToAll);

      if (!isOptinConsentValid || !isOptinSelectionValid) {
        formSubmit = false;
      }
    }

    const isMinor = this.GDPRBirthdateIsMinor(formWrapper);
    if (isMinor) {
      formSubmit = false;
    }
    const listInput = $(formWrapper).find(':input').not('.disabled, [disabled], [type="submit"], .g-recaptcha-response');

    if (ignoreHidden) {
      listInput.not(':hidden');
    }

    if (promise) {
      return new Promise((resolve) => {
        listInput.each((i, e) => {
          const valid = $(e).valid();
          if (!valid && formSubmit) {
            formSubmit = false;
          }
        });

        resolve(formSubmit);
      });
    }

    listInput.each((i, e) => {
      const valid = $(e).valid();
      if (!valid && formSubmit) {
        formSubmit = false;
      }
    });
    return formSubmit;
  }

  /**
   * remove all style element in validated form
   * @method resetForm
   * @param  {object} thisObj contain wrapper and list of input verified.
   */
  resetForm(thisObj) {
    thisObj.currentForm.on('resetForm', () => {
      if (!thisObj.$allElement) { return false; }
      thisObj.$allElement.each((i, e) => {
        $(e).removeAttr('aria-invalid')
        .closest(`.${this.param.inputStyleClass}`)
        .removeClass(`${this.param.inputStyleClass}--error ${this.param.inputStyleClass}--valid`);
        this.displayDescError(e, 'hide');
      });
      return true;
    });
  }

  /**
   * Valid input
   * @method highlightCallback
   * @param  {DOM reference}        element to validate
   */
  highlightCallback(element) {
    this.recalculHeight($(element).closest(`.${this.tarClass}`), 'noH');
    $(element).attr('aria-invalid', true)
    .closest(`.${this.param.inputStyleClass}`)
    .addClass(`${this.param.inputStyleClass}--error`)
    .removeClass(`${this.param.inputStyleClass}--valid`);
    this.displayDescError(element, 'show');
    this.recalculHeight($(element).closest(`.${this.tarClass}`), 'calcH');
  }

  /**
   * Error input
   * @method unhighlightCallback
   * @param  {DOM reference}       element to errored
   */
  unhighlightCallback(element) {
    this.recalculHeight($(element).closest(`.${this.tarClass}`), 'noH');
    $(element).attr('aria-invalid', false)
    .closest(`.${this.param.inputStyleClass}`)
    .removeClass(`${this.param.inputStyleClass}--error`)
    .addClass(`${this.param.inputStyleClass}--valid`);
    this.displayDescError(element, 'hide');
    this.recalculHeight($(element).closest(`.${this.tarClass}`), 'calcH');
  }

  /**
   * convert string chevron to html
   * @method escapeChevron
   * @param  {[type]}      string to convert
   * @return {[type]}      string converted
   */
  escapeChevron(string) {
    if (string === undefined || typeof string !== 'string') {
      return '';
    }
    return string.replace(/&lt;/mi, '<').replace(/&gt;/mi, '>');
  }

  /**
   * display description error under input
   * @method displayDescError
   * @param  {DOM reference}         target
   * @param  {string('show'|'hide')} show|hide error
   */
  displayDescError(element, display) {
    const self = this;
    const $self = $(element);
    const elemDesc = $self.data('description');
    if ($self.is('[data-valid="psi"]')) {
      const $error = $(`label.m-desc-error[for="${element.id}"]`);

      if (display === 'show') {
        $error.addClass(`${this.param.errorBaseClass}--show`)
        .removeClass(`${this.param.errorBaseClass}--hide`).attr('aria-hidden', false);
      } else {
        $error.addClass(`${this.param.errorBaseClass}--hide`)
        .removeClass(`${this.param.errorBaseClass}--show`).attr('aria-hidden', true);
      }
    } else if (elemDesc) {
      const elemId = $self.attr('id');
      let $error = $(`#${elemId}-error`);

      if (!$error.length) {
        let labelStr = $self.data('labelstr');
        if (!labelStr) {
          if (this.param.errorTemplate) {
            const template = this.escapeChevron($(`${this.param.errorTemplate}`).html());
            const renderTpl = _.template(template);
            $self.data('labelstr', renderTpl({ id: elemId, text: elemDesc }));
          } else {
            $self.data('labelstr', `<label id="${elemId}-error" for="${elemId}" class="${this.param.errorBaseClass}">${elemDesc}</label>`);
          }
          labelStr = $self.data('labelstr');
        }
        $error = $(labelStr).attr('role', 'alert');
        $self.attr('aria-describedby', `${elemId}-error`).closest(`.${this.param.inputStyleClass}`).after($error);
      }
      $(`.${this.param.closeErrorTemplateBtnClass}`).on('click', (e) => {
        e.preventDefault();
        self.displayDescError(element, 'hide');
      });

      if (display === 'show') {
        $error.addClass(`${this.param.errorBaseClass}--show`)
        .removeClass(`${this.param.errorBaseClass}--hide`).attr('aria-hidden', false);
      } else {
        $error.addClass(`${this.param.errorBaseClass}--hide`)
        .removeClass(`${this.param.errorBaseClass}--show`).attr('aria-hidden', true);
      }
    }
  }

  /**
   * password comparason methode
   * @method passwordCheck
   * @return {boolean}       return input validation
   */
  passwordCheck() {
    const dataidpwd = '[data-id="password"]:visible';
    const $password = this.$tar.find(dataidpwd);
    const $passwordConf = this.$tar.find('input[data-id="passwordConfirm"]:visible');
    const passwordValidation = new PasswordValidation();

    if ($password.length > 0) {
      $.validator.addMethod('verifPasswordRequirements', value =>
        passwordValidation.IsValid(value)
      );
      $password.rules('add', {
        verifPasswordRequirements: true,
      });
      if ($passwordConf.length > 0) {
        $.validator.addMethod('verifPassword', (value, element) => {
          const $validationGroup = $(element).closest('.validationGroup');
          const $pwd = $validationGroup.length ?
          $validationGroup.find(dataidpwd) : $(element).closest('form');
          if ($pwd.val() === value) {
            return true;
          }
          return false;
        });
        $passwordConf.rules('add', {
          verifPassword: true,
        });
      }
      return true;
    }
    return false;
  }

  /**
   * recalcul current form height
   * @method recalculHeight
   * @param  {DOM reference}       currentForm
   * @param  {string('noH'|'calcH')}       action type of calcul
   * @return {boolean}
   */
  recalculHeight(currentForm, action) {
    if (this.param.updateHeight && currentForm.closest(`${this.param.updateHeight}`).length) {
      const $target = currentForm.closest(`${this.param.updateHeight}`);
      switch (action) {
        case 'noH': {
          $target.css('height', 'auto');
          return $target;
        }
        case 'calcH': {
          const $height = $target.height();
          $target.css('height', $height).attr('data-height', $height);
          return $target;
        }
        default:
          return false;
      }
    }
    return false;
  }

  /**
   * Load QAS Email Validation script only when enabled on BackOffice
   * @method loadQASEmailValidationScript
   */
  loadQASEmailValidationScript() {
    if (OCMS.QAS.disableEmailValidation) {
      return;
    }

    /* eslint-disable */
    require('../plugins/qas.email-validator');
    /* eslint-enable */
  }

  /* eslint-disable */
  /**
   * Load QAS Address Validation script only when enabled on BackOffice
   * @method loadQASAddressValidationScript
   */
  loadQASAddressValidationScript() {
    if (OCMS.QAS.disableAddressValidation) {
      return;
    }

    /* eslint-disable */
    // require('../plugins/qas.address-validator');
    /* eslint-enable */
  }

  /**
   * Load QAS Zip Finder script only when enabled on BackOffice
   * @method loadQASZipFinderScript
   */
  loadQASZipFinderScript() {
    if (OCMS.QAS.disableZipValidation) {
      return;
    }

    OCMS.QAS.UseZipFinderV2 = OCMS.QAS.UseZipFinderV2 || false;
    /* eslint-disable */
    if (OCMS.QAS.UseZipFinderV2 === true) {
      require('../plugins/qas.zip-finder-v2');
    } else {
      require('../plugins/qas.zip-finder');
    }

    /* eslint-enable */
  }

  /**
   * Load QAS validation scripts
   *
   * QAS validation scripts should be required
   * only if QAS validation is enabled on BackOffice.
   *
   * Conditionning 'require' is not a general recommandation of ESLint.
   * For this particular situation we want ESLint to ignore those lines.
   *
   * @method loadQASValidationScript
   */
  loadQASValidationScript() {
    if (!OCMS.QAS) {
      return;
    }

    OCMS.QAS = OCMS.QAS || {};

    this.loadQASEmailValidationScript();

    this.loadQASAddressValidationScript();

    this.loadQASZipFinderScript();
  }

  /**
   * Load specific countries script
   * @method loadCountriesScript
   */
  loadCountriesScript() {
    if (OCMS.GlobalVars.Country) {
      const currentCountry = OCMS.GlobalVars.Country.replace(' ', '-');

      if ($.inArray(currentCountry, this.param.countries) !== -1) {
        /* eslint-disable */
        require(`../countryForm/${currentCountry}.form.js`);
        /* eslint-enable */
      }
    }
  }
}

function formValidator(target) {
  const newFormValid = new FormValid(target);
  newFormValid.init({
    btnSubmitClass: 'js-submit-btn',
    inputStyleClass: 'm-private-input',
    errorTemplate: '#errorTemplate',
    errorBaseClass: 'm-desc-error',
    closeErrorTemplateBtnClass: 'm-desc-error__delete',
    updateHeight: '[data-height]',
  });
}

function GetDefaultValidationResult(target) {
  const validInput = new FormValid();
  return validInput.validAllInput(target);
}

function GetDefaultValidationResultWithoutHidden(target) {
  const validInput = new FormValid();
  return validInput.validAllInput(target, true);
}

function PasswordValidationRules(password) {
  const passwordValidation = new PasswordValidation();
  return passwordValidation.IsValid(password);
}

export {
  formValidator,
  GetDefaultValidationResult,
  GetDefaultValidationResultWithoutHidden,
  PasswordValidationRules,
};

export default formValidator;



// WEBPACK FOOTER //
// ./js/common/formValid.js